import classNames from 'classnames/bind';
import styles from './TableBody.module.css';

import {
  FaqItem,
  FeedbackItem,
  ShareLink,
  NoticeItem,
  RegistrationRequest,
} from '../../types/settings';

import TableItem from './TableItem/TableItem';
interface TableBody {
  name: string;
  list:
    | ShareLink[]
    | NoticeItem[]
    | FaqItem[]
    | FeedbackItem[]
    | RegistrationRequest[];
  code?: string;
}

export default function TableBody({ name, list, code }: TableBody) {
  const cx = classNames.bind(styles);

  return (
    <div className={cx('table_list', 'table_body', 'board_body', name)}>
      {list.map((item, i) => (
        <TableItem key={i} name={name} item={item} code={code} />
      ))}
    </div>
  );
}
